/* eslint-disable jira/filename-case */
export const UNDEFINED = 'UNDEFINED' as const;
export const TODO = 'TODO' as const;
export const IN_PROGRESS = 'IN_PROGRESS' as const;
export const DONE = 'DONE' as const;

export type StatusCategory = typeof UNDEFINED | typeof TODO | typeof IN_PROGRESS | typeof DONE;

/** StatusCategory type without UNDEFINED option */
export type StrictStatusCategory = typeof TODO | typeof IN_PROGRESS | typeof DONE;

export const STATUS_CATEGORIES: readonly ['UNDEFINED', 'TODO', 'IN_PROGRESS', 'DONE'] = [
	UNDEFINED,
	TODO,
	IN_PROGRESS,
	DONE,
] as const;

const statusCategories: {
	id: string;
	statusCategory: StatusCategory;
}[] = [
	{ id: '1', statusCategory: UNDEFINED },
	{ id: '2', statusCategory: TODO },
	{ id: '4', statusCategory: IN_PROGRESS },
	{ id: '3', statusCategory: DONE },
];

export const StatusCategoryTypes: Readonly<{
	NEW: 'new';
	INDETERMINATE: 'indeterminate';
	DONE: 'done';
	UNDEFINED: 'undefined';
}> = Object.freeze({
	NEW: 'new',
	INDETERMINATE: 'indeterminate',
	DONE: 'done',
	UNDEFINED: 'undefined',
});

export const StatusCategoryIds: Readonly<{
	undefined: 1;
	new: 2;
	done: 3;
	indeterminate: 4;
}> = Object.freeze({
	[StatusCategoryTypes.UNDEFINED]: 1,
	[StatusCategoryTypes.NEW]: 2,
	[StatusCategoryTypes.DONE]: 3,
	[StatusCategoryTypes.INDETERMINATE]: 4,
});

export type StatusCategoryId = (typeof StatusCategoryIds)[keyof typeof StatusCategoryIds];

export type StatusCategoryKeys = (typeof StatusCategoryTypes)[keyof typeof StatusCategoryTypes];

export const statusCategoryKeys: StatusCategoryKeys[] = Object.values(StatusCategoryTypes);

export const statusCategoryForId = (statusCategoryId?: string | number): StatusCategory => {
	const value = statusCategories.find((sc) => sc.id === String(statusCategoryId));
	return value ? value.statusCategory : UNDEFINED;
};

export const categoryIdForStatusCategory = (statusCategory?: StatusCategory): number => {
	const value = statusCategories.find((sc) => sc.statusCategory === statusCategory);
	return Number(value ? value.id : '1');
};

export const isValidStatusCategoryKey = (key: string): key is StatusCategoryKeys =>
	statusCategoryKeys.some((statusCategoryKey) => statusCategoryKey === key);
